import PlantIcon from "assets/plant.png";
import { color } from "minimum-ui/tokens";
import styled from "styled-components";
import { H1R, H3R } from "typography/headers";

const MaintenancePage = () => {
  return (
    <Container>
      <Content>
        <Logo src="https://assets.minimum.com/logo__auth.png" />
        <ContentImage src={PlantIcon} />
        <ContentHeader>We’ll be back shortly</ContentHeader>
        <ContentBody>We’re currently down for regular maintenance.</ContentBody>
        <ContentBody>Thanks for your patience.</ContentBody>
      </Content>
    </Container>
  );
};

const Container = styled.div`
  background-color: ${color.basic.black};
  background-image: url("https://assets.minimum.com/background__auth.svg");
  background-position: 50%;
  background-size: cover;
  overflow: visible;
  min-height: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;
const Content = styled.main`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  width: 100%;
  max-width: 454px;
  padding: 64px 48px;
  background-color: ${color.basic.white};
  border-radius: 5px;
`;
const ContentHeader = styled(H1R)`
  margin-bottom: 24px;
  text-align: center;
`;
const ContentImage = styled.img`
  width: 96px;
  margin-bottom: 24px;
`;
const ContentBody = styled(H3R)`
  text-align: center;
`;
const Logo = styled.img`
  max-height: 32px;
  margin-bottom: 32px;
`;

export default MaintenancePage;
